var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlockSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,12H11.0009766V7c0-2.7568359,2.2431641-5,5-5s5,2.2431641,5,5v1h2V7c0-3.859375-3.140625-7-7-7s-7,3.140625-7,7v5h-3 c-1.6542969,0-3,1.3457031-3,3v14c0,1.6542969,1.3457031,3,3,3H26c1.6542969,0,3-1.3457031,3-3V15 C29,13.3457031,27.6542969,12,26,12z M27,29c0,0.5517578-0.4482422,1-1,1H6.0009766c-0.5517578,0-1-0.4482422-1-1V15 c0-0.5517578,0.4482422-1,1-1H26c0.5517578,0,1,0.4482422,1,1V29z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0009766,
    y: 18,
    width: 2,
    height: 8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockSmall);
export default __webpack_public_path__ + "static/media/unlock--small.7b3b9f7219a56aec72ddb7a4e1bc0c87.svg";
export { ForwardRef as ReactComponent };